/**
 * @generated SignedSource<<19474455b55a9f8b1dbe0b632a04dfce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DocumentsBlock_content$data = {
  readonly highlightedText: string | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "DocumentsBlock_content";
};
export type DocumentsBlock_content$key = {
  readonly " $data"?: DocumentsBlock_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"DocumentsBlock_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DocumentsBlock_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highlightedText",
      "storageKey": null
    }
  ],
  "type": "ComponentContentDocuments",
  "abstractKey": null
};

(node as any).hash = "136aacd658ee6f53e31def3fec4ec6fb";

export default node;
